<div class="card-title">
  <div class="layout-padding">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span><h2>Devices</h2></span>
      <div (click)="onHelpClick()" aria-label="Devices Help">
        <button mat-icon-button>
          <mat-icon>help</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="layout-padding">
  <mat-card appearance="outlined" fxFill class="card-style">
    <mat-card-title>Filters</mat-card-title>
    <div class="search">
      <mat-form-field fxFill>
        <mat-label>Company</mat-label>
        <mat-select (selectionChange)="onSelectChange($event)">
          <mat-option>
            <ngx-mat-select-search [formControl]="searchCompany" noEntriesFoundLabel="'No results found'"
                                   placeholderLabel="Search Company" [preventHomeEndKeyPropagation]="true"></ngx-mat-select-search>
            <mat-icon ngxMatSelectSearchClear>clear</mat-icon>
          </mat-option>
          <mat-option *ngFor="let company of companies | inputSearch:searchCompany?.value"
                      [value]="company">{{company.friendly}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button (click)="searchFilterActionHandler(selectedCompany)">Search</button>
    </div>
  </mat-card>

  <br>
  <mat-card appearance="outlined" style="padding: inherit">
    <app-portal-loader [loadingStatus]="loading"></app-portal-loader>
    <div fxLayout="row" fxLayoutAlign="space-between right">
      <span><h2>List of Devices</h2></span>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="!collaspe" class="buttons" (click)="collaspe = !collaspe">
            <mat-icon>fullscreen_exit</mat-icon>
            <span>Exit Fullscreen</span>
          </button>
          <button mat-menu-item *ngIf="collaspe" class="buttons" (click)="collaspe = !collaspe">
            <mat-icon>fullscreen</mat-icon>
            <span>Fullscreen</span>
          </button>
          <button mat-menu-item class="buttons" (click)="createDevice()">
            <mat-icon>add_box</mat-icon>
            <span>Create Device</span>
          </button>
        </mat-menu>

      </div>
    </div>

    <div [ngClass]="collaspe ? 'table' : 'none'">
      <app-table
        [data]="deviceList"
        [headerStream]="deviceHeader"
        (events)="onRowClick($event)"
        #deviceTable>
<!--        <mat-form-field fxFlex *ngIf='deviceTable.showFilter'>-->
<!--          <mat-label>Filter</mat-label>-->
<!--          <input matInput (keyup)="deviceTable.applyFilter($event.target.value)"-->
<!--                 placeholder="Filter through results. Ex: CTL Docker LCA">-->
<!--        </mat-form-field>-->
      </app-table>
    </div>
  </mat-card>
</div>
